export default "__VITE_ASSET__zx7kmD0b__"